import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateCoupon extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllCoupons extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteACoupon extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class EditACoupon extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Coupon/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { CreateCoupon, GetAllCoupons, DeleteACoupon, EditACoupon };
